import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration - using environment variables for security
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBjYPP7XNaspPHVxWjcDi_KFM9JlKOIYJc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tepproj.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tepproj",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tepproj.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "609219675735",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:609219675735:web:f9a183d4e2042db53e4512"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;



